import { parseReportDateForSort } from "./reportDateSortUtils";
import { getNextSortConfig } from "./dailySaleReportTableConfig";

export { getNextSortConfig };

export const GIFT_CARD_REPORT_COLUMN_FIELDS = [
  null,
  "voucher_no",
  "gc_no",
  "gc_name",
  "purchaseDate",
  "last_used_date",
  "amount",
  "total_redeemed_amount",
  "current_balance",
  "remark",
  "location_name",
  "customer_name",
  null,
];

const NUMERIC_FIELDS = new Set([
  "amount",
  "total_redeemed_amount",
  "current_balance",
]);

const DATE_FIELDS = new Set(["purchaseDate", "last_used_date", "expire_date"]);

const parseNumericValue = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const num = Number(value);
  if (Number.isFinite(num)) return num;
  const parsed = parseFloat(String(value).replace(/[^0-9.-]/g, ""));
  return Number.isFinite(parsed) ? parsed : null;
};

const getSortValue = (row, field) => {
  const value = row?.[field];
  if (value === null || value === undefined || value === "") return null;
  if (DATE_FIELDS.has(field)) return parseReportDateForSort(value);
  if (NUMERIC_FIELDS.has(field)) return parseNumericValue(value);
  return String(value).toLowerCase();
};

const compareValues = (left, right) => {
  if (left === null && right === null) return 0;
  if (left === null) return 1;
  if (right === null) return -1;
  if (typeof left === "number" && typeof right === "number") {
    return left - right;
  }
  return String(left).localeCompare(String(right), undefined, {
    sensitivity: "base",
    numeric: true,
  });
};

export const sortGiftCardReportRows = (rows, sortConfig) => {
  if (!Array.isArray(rows) || !rows.length) return rows || [];
  if (!sortConfig?.columnIndex || sortConfig.columnIndex === 0) return rows;

  const field = GIFT_CARD_REPORT_COLUMN_FIELDS[sortConfig.columnIndex];
  if (!field) return rows;

  const direction = sortConfig.direction === "desc" ? -1 : 1;

  return [...rows].sort((rowA, rowB) => {
    const comparison = compareValues(
      getSortValue(rowA, field),
      getSortValue(rowB, field)
    );
    return comparison * direction;
  });
};
